import React, { useCallback, useState } from "react";
import { FormControl, TextField } from "@mui/material";
import _ from "lodash";

interface SearchInputProps {
  placeholder: string;
  onSearchChange: (searchText: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ placeholder, onSearchChange }) => {

  const handleSearchInput = useCallback(
    _.debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      onSearchChange(value);
    }, 500),
    [onSearchChange]
  );

  return (
    <div className="filter">
      <div className="box-style">
        <div className="icon-search">
          <span className="icons-search"></span>
        </div>
        <div className="search-input">
          <FormControl fullWidth>
            <TextField
              className="no-border-textfield"
              placeholder={placeholder}
              onChange={handleSearchInput}
            />
          </FormControl>
        </div>
      </div>
    </div>
  );
};

export default SearchInput;
